import { Injectable } from '@angular/core';
import { API } from './api.service';

@Injectable()
export class PaymentsService {
    constructor(private api: API) {

    }

    public getPaymentHistory(page: number, searchQuery: any = false) {
        let queryParams = '?page=' + page;
        if (searchQuery) {
            queryParams += '&q=' + searchQuery;
        }
        return this.api.get('packages/payment-history' + queryParams);
    }

}



// WEBPACK FOOTER //
// ./src/app/api/services/payments.service.ts